import { faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import Pagination from "components/reusable/Pagination";
import { Button } from "flowbite-react";
import TransactionDetails from "Pages/Dashboard/TransactionDetails";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import TransactionsTable from "./TransactionsTable";

export default function DesktopWalletStatement({ walletRefresh }) {
  const { t } = useTranslation();
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [transactions, setTransactions] = useState(null);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });

  const [transactionState] = useState({
    start_date: "",
    end_date: "",
    status: "",
  });
  const [transactionDetailsItem, setTransactionDetailsItem] = useState({});
  const [viewDetailsShowModal, setViewDetailsShowModal] = useState(false);

  const { status } = transactionState;

  // get all transactions function-
  const getTransactions = async () => {
    try {
      const payload = {
        start_date: null,
        end_date: null,
        status,
        page,
        sort_key: sort.sort_key,
        sort_type: sort.sort_type,
      };

      const path = pathObj.walletStatement;
      const result = await apiGet(path, payload);

      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setTransactions(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      setTransactions([]);
    }
  };

  useEffect(() => {
    getTransactions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, sort, page, walletRefresh]);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handleTransactionDetailsView = (item) => {
    setTransactionDetailsItem(item);
    setViewDetailsShowModal(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-10 px-3 w-full">
        <span className="text-lg font-medium">{t("O_WALLET_STATEMENT")}</span>
        <Link to={"/wallet-window"}>
          <Button className="bg-primary py-3 px-10 rounded-xl flex gap-2 items-center">
            <FontAwesomeIcon icon={faWallet} className="text-white" size={"lg"} />
            <span className="text-base font-medium text-white">{t("WALLET_WINDOW")}</span>
          </Button>
        </Link>
      </div>
      <TransactionsTable transactions={transactions} page={paginationObj.page} setSort={setSort} sort={sort} handleTransactionDetailsView={handleTransactionDetailsView} />
      {paginationObj?.totalItems ? <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} docsLength={paginationObj.totalItems} /> : null}

      {viewDetailsShowModal && (
        <BottomSheet
          open={viewDetailsShowModal}
          title={t("O_DETAILS")}
          onClose={() => {
            setViewDetailsShowModal(false);
          }}
        >
          <TransactionDetails transactionId={transactionDetailsItem._id} />
        </BottomSheet>
      )}
    </>
  );
}
